/* UserReview.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["as", "style"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _36 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _35 = "._c2wa8stv:active{-webkit-text-decoration-line:underline;text-decoration-line:underline}";
const _34 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _33 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _32 = "._1bnx8stv:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}";
const _31 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _30 = "._3zhz1b66._3zhz1b66>span{margin-left:var(--ds-space-050,4px)}";
const _29 = "._1wyb1j6v{font-size:1rem}";
const _28 = "._ect4po1d{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,system-ui,\"Helvetica Neue\",sans-serif)}";
const _27 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _26 = "._qtt8glyw{list-style:none}";
const _25 = "._1wdoutpp:not(:last-child):after{margin-left:var(--ds-space-150,9pt)}";
const _24 = "._15621mp2:not(:last-child):after{content:\"\u2022\"}";
const _23 = "._1n261g80{flex-wrap:wrap}";
const _22 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _21 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _20 = "._gy1pu2gc{column-gap:var(--ds-space-100,8px)}";
const _19 = "._4cvr1h6o{align-items:center}";
const _18 = "._18s8tvx8{margin:var(--ds-space-100,8px) 0 var(--ds-space-200,1pc) 0}";
const _17 = "._1bsb1osq{width:100%}";
const _16 = "@media not all and (min-width:48rem){._4uro1wug{margin-left:auto}}";
const _15 = "@media not all and (min-width:48rem){._suga1txw{display:flex}._1d4sutpp{column-gap:var(--ds-space-150,9pt)}._14adu2gc{margin-bottom:var(--ds-space-100,8px)}}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import LoadingButton from '@atlaskit/button/loading-button';
import { media } from '@atlaskit/primitives';
import { BodySmall, SubtleLink } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _14 = "@media not all and (min-width:64rem){._1uby1jfw{margin-bottom:var(--ds-space-500,40px)}}";
const _13 = "@media not all and (min-width:48rem){._1gde1bp4{flex-direction:column}._1d4sidpf{column-gap:0}}";
const _12 = "._dxh9idpf:last-child{margin-bottom:0}";
const _11 = "._otyroahv{margin-bottom:var(--ds-space-600,3pc)}";
const _10 = "._gy1putpp{column-gap:var(--ds-space-150,9pt)}";
const _9 = "._1e0c1txw{display:flex}";
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._n3tdidpf{padding-bottom:0}";
const _6 = "._u5f3idpf{padding-right:0}";
const _5 = "._ca0qidpf{padding-top:0}";
const _4 = "._18u0idpf{margin-left:0}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._2hwxidpf{margin-right:0}";
const _ = "._19pkidpf{margin-top:0}";
export const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _gy1putpp _otyroahv _dxh9idpf _1gde1bp4 _1d4sidpf _1uby1jfw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const Header = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_suga1txw _1d4sutpp _14adu2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
export const HeaderRight = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4uro1wug", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HeaderRight.displayName = 'HeaderRight';
}
export const Content = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}
export const RatingsContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _9, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8tvx8 _1e0c1txw _4cvr1h6o _gy1pu2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RatingsContainer.displayName = 'RatingsContainer';
}
export const SubtleText = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_21, _]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1gjq _19pkidpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SubtleText.displayName = 'SubtleText';
}
export const ActionsContainer = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _19, _10, _22, _23]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _gy1putpp _19pkpxbi _1n261g80", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionsContainer.displayName = 'ActionsContainer';
}
export const ActionsContainerElement = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _24, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _15621mp2 _1wdoutpp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ActionsContainerElement.displayName = 'ActionsContainerElement';
}
export const ResponseContainer = forwardRef((_ref9, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref9,
    __cmplp = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_26, _5, _6, _7, _8, _, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ResponseContainer.displayName = 'ResponseContainer';
}
export const DeleteModalButtons = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_27, _28, _29, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _ect4po1d _1wyb1j6v _1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DeleteModalButtons.displayName = 'DeleteModalButtons';
}
export const LoadingButtonStyled = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = LoadingButton,
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_30]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_3zhz1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LoadingButtonStyled.displayName = 'LoadingButtonStyled';
}
export const SubtleLinkStyled = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = SubtleLink,
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_29, _31, _32, _33, _34, _35, _36]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wyb1j6v _9oik18uv _1bnx8stv _jf4cnqa1 _1nrm18uv _c2wa8stv _1iohnqa1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SubtleLinkStyled.displayName = 'SubtleLinkStyled';
}